import { store } from "@/store/store";
import { VuexModule, Mutation, getModule, Module, Action } from "vuex-module-decorators";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";

@Module({ namespaced: true, name: "telemetriaClienteModule", store, dynamic: true })
class telemetriaClienteModule extends VuexModule {
    public telemetrias: any[] = [];
    public telemetriasByCliente: any[] = [];
    public topBusquedas: Array<{ termino: string; total: number }> = [];
    public topProductos: Array<{ id_producto: number; visitas: number; nombre: string; imagen: string }> = [];
    public loading: boolean = false;

    // Obtiene toda la telemetría (dashboard global)
    @Action({ commit: "onGetAll" })
    public async getAll() {
        return await ssmHttpService.get(API.telemetria_cliente, undefined, false);
    }

    @Mutation
    public onGetAll(res: any[]) {
        this.telemetrias = res || [];
    }

    // Obtiene la telemetría de un cliente concreto para su ficha
    @Action({ commit: "onGetByCliente" })
    public async getByCliente(idCliente: number) {
        return await ssmHttpService.get(API.telemetria_cliente_by_client + idCliente, undefined, false);
    }

    @Mutation
    public onGetByCliente(res: any[]) {
        this.telemetriasByCliente = res || [];
    }

    @Action
    public async postEvento(evento: object) {
        try {
            await ssmHttpService.post(API.telemetria_cliente, evento, false);
        } catch (_) { /* silent — no bloquear navegación */ }
    }

    @Action({ commit: "onGetTopBusquedas" })
    public async getTopBusquedas(top: number = 10) {
        return await ssmHttpService.get(API.telemetria_top_busquedas + "?top=" + top, undefined, false);
    }

    @Action({ commit: "onGetTopProductos" })
    public async getTopProductos(top: number = 8) {
        return await ssmHttpService.get(API.telemetria_top_productos + "?top=" + top, undefined, false);
    }

    @Mutation
    public onGetTopBusquedas(res: any[]) {
        this.topBusquedas = res || [];
    }

    @Mutation
    public onGetTopProductos(res: any[]) {
        this.topProductos = res || [];
    }
}

export default getModule(telemetriaClienteModule);
